// English locale - V2 (currently mostly empty, falls back to FR via Proxy).
// Only essential UI strings (language banner, switcher) are translated for now.
import fr from "./fr";

const en = {
  ...fr,
  langBanner: {
    ...fr.langBanner,
    enTitle: "English version coming soon",
    enBody: "We're showing the French version for now. Sign up to be notified when English content goes live.",
    switchToFr: "View in French",
    dismiss: "Dismiss",
  },
};

export default en;
